import { Component, inject, Input } from '@angular/core';
import { UserDataService } from '../../../../../../services/user-data.service';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { ModalableAccessCode } from '../../../../../../models/modalable-access-code';
import { ModalService } from '../../../../../../services/modal.service';
import { DisabledFeatureModalable } from '../../../../../../models/disabled-feature-modalable';
import { AssetPipe } from '../../../../../../pipes/asset.pipe';
import { environment } from '../../../../../../../environments/environment';
import { RouteService } from '../../../../../../services/route.service';

// eslint-disable complexity
@Component({
    selector: 'app-feature-disabled-plus',
    templateUrl: './feature-disabled-plus.component.html',
    styleUrls: ['./feature-disabled-plus.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class FeatureDisabledPlusComponent {

    @Input() hasBookAccessCode = false;
    @Input() requiresPremiumPlus = true;

    protected routeService = inject(RouteService);
    protected userDataService = inject(UserDataService);
    protected applicationStateService = inject(ApplicationStateService);
    protected modalService = inject(ModalService);

    protected successMessage: string | null = null;
    protected errorMessage: string | null = null;

    protected onChangeAccessCodeClicked(): void {
        this.modalService.closeModal(DisabledFeatureModalable.MODAL_ID);
        this.modalService.openModal(new ModalableAccessCode());
    }

    get trialAvailable(): boolean {
        const accessCode = this.applicationStateService.userData?.bookAccessCode;

        return accessCode?.trialAvailable && this.hasBookAccessCode && this.requiresPremiumPlus;
    }

    get trialDays(): number {
        return this.applicationStateService.userData?.bookAccessCode?.trialDays ?? 14;
    }

    protected onStartTrialClicked(): void {
        const code = this.applicationStateService.userData?.bookAccessCode?.quickLink;
        if (!code) {
            return;
        }

        this.successMessage = null;
        this.errorMessage = null;
        this.userDataService.startTrial(code).then((response: any) => {
            this.successMessage = response?.message;
            setTimeout(() => {
                this.reloadPage();
            }, 2000);
        }).catch((error: any) => {
            this.errorMessage = error?.message || error || 'Ein Fehler ist aufgetreten.';
        });
    }

    protected reloadPage(): void {
        location.reload();
    }

    protected getUpgradeRoute(code: string): string {
        return this.routeService.getAbsoluteRoute(environment.endpointUrls.codeUpgrade, {code});
    }
}
